import axios from 'axios'
import {ParamsModel} from 'src/app/modules/common/Model'
import {DeleteSubsidiaryPageModel, SortSubsidiaryPageModel} from '../Model'
import {SubsidiaryPageModel} from '../Model/SubsidiaryPageModel'

const API_URL = window.__RUNTIME_CONFIG__.REACT_APP_API_URL

export const SUBSIDIARY_PAGE_API = `${API_URL}/subsidiary-page`

export const service = {
  getSubsidiaryPage: (params: ParamsModel) => {
    return axios.get(SUBSIDIARY_PAGE_API, {params})
  },
  getAllSubsidiaryPage: () => {
    return axios.get(`${SUBSIDIARY_PAGE_API}/list`)
  },

  addSubsidiaryPage: (data: any) => {
    return axios.post(SUBSIDIARY_PAGE_API, data)
  },

  updateSubsidiaryPage: (body: SubsidiaryPageModel, id: string) => {
    return axios.patch(`${SUBSIDIARY_PAGE_API}/${id}`, body)
  },

  deleteSubsidiaryPage: (data: DeleteSubsidiaryPageModel) => {
    return axios.delete(SUBSIDIARY_PAGE_API, {data})
  },

  enableSubsidiaryPage: (data: Array<string>) => {
    const selectedSubsidiaryPage = {
      subsidiaryPageId: data,
    }
    return axios.patch(`${SUBSIDIARY_PAGE_API}/enable`, selectedSubsidiaryPage)
  },

  disableSubsidiaryPage: (data: Array<string>) => {
    const selectedSubsidiaryPage = {
      subsidiaryPageId: data,
    }
    return axios.patch(`${SUBSIDIARY_PAGE_API}/disable`, selectedSubsidiaryPage)
  },

  singleEnableSubsidiaryPage: (data: Array<string>) => {
    const selectedSubsidiaryPage = {
      subsidiaryPageId: [data],
    }
    return axios.patch(`${SUBSIDIARY_PAGE_API}/enable`, selectedSubsidiaryPage)
  },

  singleDisableSubsidiaryPage: (data: Array<string>) => {
    const selectedSubsidiaryPage = {
      subsidiaryPageId: [data],
    }
    return axios.patch(`${SUBSIDIARY_PAGE_API}/disable`, selectedSubsidiaryPage)
  },

  sortSubsidiaryPage: (body: SortSubsidiaryPageModel) => {
    return axios.patch(`${SUBSIDIARY_PAGE_API}/sort`, body)
  },
}
